import { render, staticRenderFns } from "./kw_weekly_calendar.vue?vue&type=template&id=39d31a90&scoped=true&"
import script from "./kw_weekly_calendar.vue?vue&type=script&lang=js&"
export * from "./kw_weekly_calendar.vue?vue&type=script&lang=js&"
import style0 from "./kw_weekly_calendar.vue?vue&type=style&index=0&id=39d31a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d31a90",
  null
  
)

component.options.__file = "kw_weekly_calendar.vue"
export default component.exports